module.exports = __webpack_public_path__ + "static/media/parallax-2.9c03af09.webp";